var map = {
	"./add-user.svg": 1131,
	"./add.svg": 419,
	"./addagentcheck.svg": 1132,
	"./agent_profile.svg": 633,
	"./agenttransferflow.svg": 1133,
	"./appointmentflow.svg": 1134,
	"./appypie-livechat.svg": 1135,
	"./attachment.svg": 1136,
	"./badge.svg": 1137,
	"./blank-file.png": 630,
	"./book.svg": 192,
	"./bottom.png": 1138,
	"./bottomD.png": 1139,
	"./calendar.png": 1140,
	"./calendar.svg": 1141,
	"./calendly.svg": 1142,
	"./chatHistory.svg": 1143,
	"./check-mark.svg": 246,
	"./checked.png": 247,
	"./checked.svg": 1144,
	"./circle.svg": 1145,
	"./computer-icon.svg": 613,
	"./croseBgWhite.svg": 1146,
	"./delete-button.svg": 1147,
	"./delete-new.svg": 286,
	"./delete.svg": 1148,
	"./deleteNew.svg": 424,
	"./dislike.png": 191,
	"./dislike.svg": 287,
	"./down-arrow.svg": 760,
	"./downarrow.svg": 1149,
	"./download.gif": 634,
	"./drp.svg": 1150,
	"./edit-black.svg": 1151,
	"./edit-icon.svg": 614,
	"./edit-tbl.svg": 1152,
	"./edit.png": 635,
	"./edit.svg": 1153,
	"./editNew.svg": 425,
	"./emojiSmile.svg": 1154,
	"./facebook.svg": 1155,
	"./filter.svg": 1156,
	"./groupVisitors.svg": 1157,
	"./home-icon.svg": 426,
	"./iconLogo.svg": 1158,
	"./image-file.png": 1159,
	"./img-left.svg": 1160,
	"./img-only.svg": 1161,
	"./img-right.svg": 1162,
	"./inactive-chatbot.svg": 417,
	"./info.png": 40,
	"./infoIcon.svg": 213,
	"./inquiryflow.svg": 1163,
	"./language.svg": 418,
	"./left-arrow.svg": 1164,
	"./leftArrow.svg": 1165,
	"./leftArrowBlack.svg": 1166,
	"./like.png": 190,
	"./like.svg": 288,
	"./link-symbol.svg": 214,
	"./loaderUpload.gif": 1167,
	"./loaderUpload3.gif": 626,
	"./logout.svg": 1168,
	"./logoutShoutDown.svg": 1169,
	"./menu.svg": 1170,
	"./multiply.svg": 1171,
	"./next.svg": 1172,
	"./offline.png": 1173,
	"./online.png": 1174,
	"./plus.svg": 1175,
	"./prev.svg": 1176,
	"./refreshud.svg": 1177,
	"./right-arrow.svg": 1178,
	"./right-panel-crose.svg": 62,
	"./right.png": 1179,
	"./rightArrow.svg": 1180,
	"./save-money.svg": 636,
	"./search.svg": 1181,
	"./selectArrowSvg.svg": 1182,
	"./selectdroparrow.svg": 1183,
	"./send-icon.svg": 248,
	"./sendBtn.svg": 1184,
	"./setting.svg": 1185,
	"./settingsNew.svg": 1186,
	"./setup/_display1.svg": 1187,
	"./setup/_display2.svg": 1188,
	"./setup/_display3.svg": 1189,
	"./setup/_display4.svg": 1190,
	"./setup/agent_profile.svg": 1191,
	"./setup/bottom.svg": 1192,
	"./setup/checked1.svg": 1193,
	"./setup/checkedblack.svg": 1194,
	"./setup/closeAddTimeoff.svg": 1195,
	"./setup/deleteGrey.svg": 1196,
	"./setup/deletetime.svg": 1197,
	"./setup/display1.svg": 1198,
	"./setup/display2.svg": 1199,
	"./setup/display3.png": 1200,
	"./setup/display3.svg": 1201,
	"./setup/display4.png": 1202,
	"./setup/display4.svg": 1203,
	"./setup/edit.svg": 1204,
	"./setup/plus.svg": 1205,
	"./setup/plusGrey.svg": 1206,
	"./setup/refresh.gif": 1207,
	"./setup/refresh.svg": 1208,
	"./setup/right.svg": 1209,
	"./setup/setupAccordian1.svg": 1210,
	"./setup/tick.png": 1211,
	"./setup/warning.svg": 1212,
	"./sheets.svg": 1213,
	"./sort-descending.svg": 610,
	"./starblue.svg": 96,
	"./stargray.svg": 1214,
	"./staryellow.svg": 97,
	"./status-arrow.svg": 1215,
	"./table-more-vertical.svg": 188,
	"./text-only.svg": 1216,
	"./ticket.svg": 1217,
	"./twitter.svg": 1218,
	"./two-left-arrows.svg": 1219,
	"./type1.gif": 414,
	"./upload.svg": 1220,
	"./visitClose.svg": 1221,
	"./visitorPanelRight.svg": 1222,
	"./warning.svg": 427,
	"./whatsapp.svg": 1223,
	"./winuser.svg": 1224,
	"./zoom.svg": 1225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 245;